export const CategoryService = Symbol.for('CategoryService');
